<template>
  <preloader-overlay></preloader-overlay>
</template>

<script>
import { apiCommon } from 'lib/utils/axios';

import restoreConfirmRequest from 'api/requests/restore/restoreConfirm';

import AuthService from '@/services/auth';

import PreloaderOverlay from 'molecules/common/PreloaderOverlay';

export default {
  name: 'ConfirmationRestore',
  components: {
    PreloaderOverlay,
  },
  created() {
    this.restoreConfirm();
  },
  methods: {
    async restoreConfirm() {
      try {
        const { data } = await restoreConfirmRequest(apiCommon, this.$route.params.key);
        await AuthService.refreshToken(data.token);

        this.$router.push({ name: 'cabinet' });
      } catch {
        this.$alert({
          type: 'warning',
          text: 'restore.confirm.request.error',
        });

        this.$router.push({ name: 'login' });
      }
    },
  },
};
</script>
